
/**
 * Module dependencies.
 */

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';
import { handleRequestError, request } from 'src/core/utils/requests';

/**
 * Export `fetchProductBaseFormats`.
 */

export async function fetchProductBaseFormats() {
  const endpoint = getApiEndpoint('getProductBaseFormats');

  try {
    const { data } = await request.get(endpoint);

    return data?.data;
  } catch (error) {
    handleRequestError(error);
  }
}
